import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { PicklistItemUiInterface } from './../../interfaces/picklist.interface';

@Component({
  selector: 'lum-picklist-item-details',
  templateUrl: './picklist-item-details.component.html',
  styleUrls: ['./picklist-item-details.component.scss'],
})
export class PicklistItemDetailsComponent implements OnInit {
  item :PicklistItemUiInterface;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data :{
      item :PicklistItemUiInterface;
    },
  ) {}

  ngOnInit() :void {
    this.item = this.data.item;
  }
}
